<template>
  <div class="overflow-hidden mb-4 flex-col flex">
    <AppDataProperty
      contentId="matchFilters"
      @dataAvailable="
        data => {
          setFilters(data?.metaData?.filters)
        }
      "
      isComponent
    />

    <div class="absolute top-8 right-8" @click="$router.back()">
      <div class="w-8 h-8 bg-white rounded-full p-2">
        <img src="@/assets/images/all/close-blue.svg" alt="" />
      </div>
    </div>
    <div class="gap-5 px-6 title-color h-[40px]">
      <div class="textComponent text-xl font-semibold text-center">
        {{ $t('matches.filters.title') }}
      </div>
    </div>
    <FormComponent
      class="-mb-4 w-full px-6"
      :fields="[
        {
          label: '',
          placeHolder: $t('matches.filters.searchPlaceHolder'),
          type: 'text',
          propertyName: 'search',
        },
      ]"
      @fieldChanged="
        data => {
          this.searchText = data.search || ''
        }
      "
    >
      <template #submitButton>
        <div></div>
      </template>
    </FormComponent>
    <div
      v-for="i in [0, 1]"
      :key="i"
      class="px-4 group relative matchesScrollContainer max-h-[40%]"
      :style="{
        height:
          (i == 0 ? secectedFilterPlace : notSelectedFiltersPlaces) * 50 + 'px',
      }"
    >
      <ListComponent
        v-if="true || matchFiltersToShow.length"
        v-slot="slotData"
        class="relative h-full overflow-auto"
        :itemContainerHeight="50"
        :itemsClasses="[]"
        directUseItems
        :allItems="
          i == 0 ? selectedFiltersSearched : notSelectedFiltersSearched
        "
        :loadingMoreEnd="false"
        ref="list"
      >
        <div class="px-2 h-full">
          <div
            class="h-full rounded-[20px] ripple"
            @click="toogleFilterSelection(slotData.data?.item)"
          >
            <div
              class="shimmerElement h-[85%]"
              v-if="!slotData.data?.item?.id || slotData.data?.item?.shimmer"
            ></div>
            <div class="p-4 h-full" v-else>
              <div class="flex justify-between items-center gap-4">
                <div>
                  {{ slotData.data.item.name }}
                </div>
                <div
                  class="w-8 min-w-8 h-8"
                  :class="{
                    'opacity-20': !selectedFiltersObject[slotData.data.item.id],
                  }"
                >
                  <div class="w-full h-full">
                    <img
                      v-if="$ColorTheme.isLight()"
                      src="@/assets/images/all/heart.svg"
                      alt=""
                    />
                    <img
                      v-else
                      src="@/assets/images/all/heart-white.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ListComponent>
    </div>
    <div class="py-2"></div>
    <div class="px-6 mt-auto">
      <button class="buttonComponent w-full" @click="saveFilters">
        {{ $t('matches.filters.save') }}
      </button>
    </div>
    <div class="py-4"></div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ListComponent from '../utils/ListComponentVirtualScroll.vue'
import AppDataProperty from './AppDataProperty.vue'
import FormComponent from '../utils/FormComponent.vue'

export default defineComponent({
  name: 'LiveMatches',
  components: { AppDataProperty, ListComponent, FormComponent },
  props: {},
  data() {
    return {
      shimmerMatches: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],
      showAll: true,
      matchFilters: [],
      eventsIds: [],
      selectedFilters: this.$QuickStorage.getStored('selectedFilters') || [],
      secectedFilterPlace: 0,
      notSelectedFiltersPlaces: 0,
      searchText: '',
    }
  },
  mounted() {
    this.matchFilters = JSON.parse(JSON.stringify(this.shimmerMatches))
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    toogleFilterSelection(newFilter) {
      if (this.matchFilters[0].shimmer) return
      const foundFilter = this.selectedFilters.find(
        filter => filter.id == newFilter.id,
      )
      if (foundFilter) {
        this.selectedFilters = this.selectedFilters.filter(
          filter => filter.id !== newFilter.id,
        )
      } else {
        this.selectedFilters.unshift(newFilter)
      }
      this.$forceUpdate()
    },
    computeFiltersHeight() {
      let maxPlaces = 6
      try {
        if (document.body.offsetHeight > 700) maxPlaces = 8
        if (document.body.offsetHeight > 800) maxPlaces = 10
        if (document.body.offsetHeight > 900) maxPlaces = 12
      } catch (error) {
        console.log(error)
      }
      const midPlaces = maxPlaces / 2
      let secectedFilterPlace = Math.min(
        this.selectedFiltersSearched.length,
        maxPlaces,
      )
      if (
        secectedFilterPlace > midPlaces &&
        this.notSelectedFiltersSearched.length > midPlaces
      )
        secectedFilterPlace = midPlaces
      else if (secectedFilterPlace > midPlaces)
        secectedFilterPlace = maxPlaces - this.notSelectedFiltersSearched.length

      let notSelectedFiltersPlaces = Math.min(
        maxPlaces - secectedFilterPlace,
        this.notSelectedFiltersSearched.length,
      )
      this.secectedFilterPlace = secectedFilterPlace
      this.notSelectedFiltersPlaces = notSelectedFiltersPlaces
      // this.$forceUpdate()
    },
    setFilters(filters) {
      if (!filters || !filters[0]) return
      if (!this.matchFilters[0].shimmer) return
      this.matchFilters = filters
    },
    saveFilters() {
      this.$QuickStorage.storeData('selectedFilters', this.selectedFilters)
      this.$Events.dispatchEvent('match_filters_updated', this.selectedFilters)
      this.$router.back()
    },
  },
  computed: {
    selectedFiltersObject() {
      const object = {}
      this.selectedFilters.forEach(filter => {
        object[filter.id] = true
      })
      return object
    },
    selectedFiltersSearched() {
      return this.selectedFilters.filter(filter => {
        if (!this.searchText) return true
        return new RegExp(this.searchText, 'i').test(filter.name)
      })
    },
    notSelectedFiltersSearched() {
      return this.matchFilters
        .filter(filter => !this.selectedFiltersObject[filter.id])
        .filter(filter => {
          if (!this.searchText) return true
          return new RegExp(this.searchText, 'i').test(filter.name)
        })
    },
  },
  watch: {
    matchFilters: {
      immediate: true,
      deep: true,
      handler() {
        this.computeFiltersHeight()
      },
    },
    selectedFilters: {
      immediate: true,
      deep: true,
      handler() {
        this.computeFiltersHeight()
      },
    },
    searchText() {
      this.computeFiltersHeight()
    },
  },
})
</script>

<style scoped></style>
